import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_LOADTOKENWA;

export default {
  update(payload) {
    return baseApi.post(resource, payload);
  },
};
